import React from "react"
export function Clock(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <g
        id="prefix__Artboard-Copy-17"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm0 1a9 9 0 100 18 9 9 0 000-18zm.509 3.005V9.5h3.993v1H10a.5.5 0 01-.5-.5v-.5h.009V4.005h1z"
          id="prefix__Shape"
          fill="currentColor"
          fillRule="nonzero"
        />
      </g>
    </svg>
  )
}
